

const sortBy = (data, key) => {
    return data.toSorted((a,b) => (a[key] || '').localeCompare((b[key] || '')))
}

export default sortBy